import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss']
})
export class SkeletonLoaderComponent implements OnInit {

  @Input() skeletonType: string;

  /* SKELETON TYPE:
    table,
    cardsContainer,
    carousel
  */

  constructor() { }

  ngOnInit(): void {
  }

}
